<script>
	import {API,http_headers,SPINNER} from '../global.js'
	import Pago from './pago.svelte'
	
	export let data = {info:{IdCliente:''}}

	let idcliente = data.info.IdCliente || 0

	let loading = false
	let page=0
	let rpp=7
	let eof=false
	let buscar_cliente= idcliente
	let buscar_estado = ''
	let estados = ["PEND","OK","RECH","OK-CUOTA1","OK-RE"]
	let update = false
	let nuevo_estado = ''

	let buscar_moneda = ''
	let buscar_concepto = ''

	let tipo_cobranza= {}
	let cobranzas = []
	let agregar_pago = false
	let cobranza = {}

	$: refresh = async()=>{
		let res = await fetch(`${API}/cliente-pagos/${idcliente}/${update}?e=${buscar_estado}&m=${buscar_moneda}&c=${buscar_concepto}&p=${page}&rpp=${rpp}`)
		const ds = await res.json()
		return ds || []
	}

	const buscar = () => {
		cliente = buscar_cliente || 0
	}

	const actualizar = () => {
		update = !update
		//get_estados()
	}
	
</script>

{#if !loading}
	<div class="container mt-3">
		{#await refresh()}
			<i class="spinner"></i>
		{:then ds}
			<button class="btn btn-primary btn-sm mb-2" on:click={actualizar}>Actualizar</button>
			{#each ds.data as item, index}
				{#if (new Date(item.lastupdate))>(new Date('2021-11-01'))}
					<Pago {item} />
				{/if}
					
			{:else}
				<p>No se registran gestiones de pago.</p>
			{/each}
			{:catch err}
			  	<p>No hay datos {err}</p>
		{/await}
	</div>
{:else}
	<p>Loading....</p>
{/if}

